import type { MouseEvent } from "react";
import { ProviderIcon } from "./ProviderIcon";
import type { HarperProvider, ProviderIconName } from "./provider-options";

const PROVIDER_LABELS: Partial<Record<HarperProvider, string>> = {
  openai: "OpenAI / GPT 5.6",
  nous: "Nous Portal",
  anthropic: "Anthropic",
  moonshot: "Moonshot / Kimi K3",
};

const PROVIDER_ICONS: Partial<Record<HarperProvider, ProviderIconName>> = {
  openai: "openai",
  nous: "chip",
  anthropic: "anthropic",
  moonshot: "moonshot",
};

interface FintheonProviderTriggerProps {
  provider: HarperProvider;
  compact?: boolean;
  open?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

export function FintheonProviderTrigger({
  provider,
  compact,
  open = false,
  onClick,
}: FintheonProviderTriggerProps) {
  const currentProvider = PROVIDER_LABELS[provider] ?? "Provider";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-expanded={open}
      aria-haspopup="menu"
      aria-label={`Choose chat provider: ${currentProvider}`}
      data-fintheon-provider-trigger="active"
      className={`fintheon-provider-trigger flex items-center gap-1.5 rounded-lg text-[var(--fintheon-accent)] transition-colors hover:bg-[var(--fintheon-accent)]/10 ${
        compact ? "px-1.5" : "px-2"
      }`}
      style={{ height: 28 }}
      title={`Chat connection: ${currentProvider}`}
    >
      <ProviderIcon
        icon={PROVIDER_ICONS[provider] ?? "chip"}
        className="h-3.5 w-3.5 shrink-0"
      />
      {!compact ? (
        <span
          className="fintheon-provider-trigger__label"
          style={{
            fontSize: 11,
            color: "var(--fintheon-text)",
            opacity: 0.82,
          }}
        >
          {currentProvider}
        </span>
      ) : null}
    </button>
  );
}
